<script>
export default {
    name: 'IconInformation'
}
</script>
<template>
    <svg
        class="base-icon icon-information"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm.784-16.8c1.057 0 1.924.335 2.601 1.004.677.67 1.015 1.523 1.015 2.561 0 1.016-.338 1.875-1.015 2.58-.677.703-1.544 1.055-2.6 1.055-1.037 0-1.893-.352-2.57-1.056-.677-.704-1.015-1.563-1.015-2.579 0-1.038.333-1.892 1-2.561.665-.67 1.527-1.004 2.584-1.004zm-.62-21.6c2.716 0 4.9.647 6.555 1.941 1.654 1.294 2.481 3.105 2.481 5.432 0 1.071-.16 2.02-.48 2.843-.319.823-.7 1.516-1.146 2.078a22.448 22.448 0 01-1.728 1.902c-.776.758-1.346 1.405-1.711 1.941a3.171 3.171 0 00-.541 1.63l-.007.233h-6.092l.005-.322c.039-1.163.288-2.134.748-2.913.452-.765 1.088-1.599 1.91-2.5l.28-.304c.662-.706 1.153-1.3 1.472-1.785.32-.483.48-1 .48-1.549 0-.758-.28-1.366-.84-1.823-.558-.458-1.283-.686-2.172-.686a4.36 4.36 0 00-2.482.745c-.659.441-1.205 1.038-1.64 1.79l-.157.288L22 23.404l.18-.338c.922-1.669 2.186-2.98 3.79-3.937 1.711-1.02 3.776-1.529 6.195-1.529z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
